import React, { useCallback, useRef } from "react";

import { filterInternalAttachments } from "../../../../utils/internalAttachments";

/** Envolve qualquer gatilho (ícone, botão, card) e abre o seletor de arquivos.
 *  O `<input>` é irmão do gatilho, e não filho: os itens do CommandBar são `<div>`,
 *  então um input dentro deles não seria acionado por clique.
 */
const InternalUploadFiles = ({ children, onSelectFiles, onErrors, className }) => {
    const fileInputRef = useRef(null);

    const handleUploadFiles = useCallback((e) => {
        const files = Array.from(e.target.files || []);
        if (files.length > 0) {
            const { acceptedFiles, errors } = filterInternalAttachments(files);
            if (onErrors) onErrors(errors);
            if (acceptedFiles.length > 0) onSelectFiles(acceptedFiles);
            /** Zera o valor para que selecionar o mesmo arquivo de novo dispare o onChange. */
            e.target.value = "";
        }
    }, [onSelectFiles, onErrors]);

    return (
        <>
            <div className={className} onClick={() => fileInputRef.current.click()}>
                {children}
            </div>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleUploadFiles}
                multiple
                hidden
            />
        </>
    );
}

export default InternalUploadFiles;
